import React, { memo, useEffect, useMemo } from "react";
import styles from "./Sidebar.module.scss";
import { generalData as sidebarItems } from "Shared/Constants/sidebar";
import cn from "classnames";
import { useSelector } from "react-redux";
import { selectPersonalGeneral } from "Redux/CompanyProps/slice";
import { useAppDispatch } from "Redux/store";
import { getPersonalGeneral } from "Redux/CompanyProps/reducer";
import Icon from "Components/UI/Icon/Icon";
import { NewLogoIcon } from "Assets";
import SidebarHeaderItem from "./SidebarHeaderItem";
import { Link } from "react-router-dom";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";
import {
  selectDefaultRoute,
  selectPermissions,
  selectPermissionsLoading,
} from "Redux/Role/slice";
import { PERMISSIONS } from "Shared/Types/permissions";

const SidebarNew: React.FC = () => {
  const dispatch = useAppDispatch();

  const companyInfo = useSelector(selectPersonalGeneral);
  const permissions = useSelector(selectPermissions);
  const defaultRoute = useSelector(selectDefaultRoute);
  const loadingPermissions = useSelector(selectPermissionsLoading);

  const filteredSidebarItems = useMemo(() => {
    if (!permissions) return [];
    if (permissions.has_full_access) return sidebarItems;
    return sidebarItems
      .map((item) => {
        const filteredSubMenu = item.subMenu
          .map((subItem) => {
            // To assign Array with multiple types
            let subsubItems =
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              subItem.subMenu.filter(
                (subsubItem: any) =>
                  !subsubItem.permissions ||
                  subsubItem.permissions.some((permission: PERMISSIONS) =>
                    permissions.available_permissions.has(permission)
                  )
              ) || [];
            let defaultAccess = true;
            if (
              subItem.modules &&
              subItem.modules.every(
                (module) => !permissions.modules.has(module)
              )
            ) {
              subsubItems = [];
              defaultAccess = false;
            }

            return {
              ...subItem,
              subMenu: subsubItems,
              hasAccess: !!subsubItems?.length || defaultAccess,
            };
          })
          .filter((subItem) => subItem.hasAccess);
        return {
          ...item,
          hasAccess: !!filteredSubMenu.length,
          subMenu: filteredSubMenu,
        };
      })
      .filter((item) => item.hasAccess);
  }, [permissions]);

  useEffect(() => {
    dispatch(getPersonalGeneral());
  }, []);

  return (
    <div className={cn(styles.sidebar)}>
      <Link to={defaultRoute}>
        {companyInfo?.logo?.file ? (
          <img
            className={styles.sidebar__logo}
            src={companyInfo?.logo.file}
            alt="/"
          />
        ) : (
          <div className={styles.sidebar__logo}>
            <Icon
              height={80}
              component={NewLogoIcon}
              alt="Easy Fleet"
              fontSize="small"
            />
          </div>
        )}
      </Link>
      {loadingPermissions ? (
        <SkeletonLoader
          width="165px"
          height="550px"
          className={styles.sidebar__general}
        />
      ) : (
        <div className={styles.sidebar__general}>
          {filteredSidebarItems.map((item) => (
            <SidebarHeaderItem
              key={item.title}
              title={item.title}
              subMenu={item.subMenu}
              icon={item.icon}
            />
          ))}
        </div>
      )}
    </div>
  );
};
export default memo(SidebarNew);
